export default {"src":"/_next/static/media/Polygon_Hermez.b8fbbf0d.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};